module.exports = __webpack_public_path__ + "img/projects.a0f539ba.png";